<template>
    <div class="ChurchList">
        <h2>Church Relationships <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Territory:</label>
                        <select class="form-control" v-model="Filters.Region">
                            <option value="All">All</option>
                            <option value="High Desert">High Desert</option>
                            <option value="Low Desert">Low Desert</option>
                            <option value="West Riverside">West Riverside</option>
                            <option value="West/South Riverside">West/South Riverside</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Region:</label>
                        <select class="form-control" v-model="Filters.SubProgramID">
                            <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="">All</option>
                            <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Owner of Relationship:</label>
                        <select class="form-control" v-model="Filters.OwnerOfRelationship">
                            <option value="">All</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Clients:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        <!--<div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-4"></div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label>Search Clients:</label>
                    <input type="text" class="form-control" v-model="TableSearch" />
                </div>
            </div>
        </div>-->
    </form>
        <vuetable :fields="ChurchTableOptions.Fields"
                  pagination-path=""
                  :api-mode="false"
                  class="vue-datatable"
                  :data-manager="DataManager"
                  ref="datatable"
                  id="churchdatatableid">

            <template slot="ChurchRecordLink" scope="props">
                <div class="ChurchRecordLink">
                    <span class="underline pointer" @click="OpenChurchRecord(props.rowData.Church.Id, props.rowData)">{{ props.rowData.Church.Name }}</span>
                </div>
            </template>
            <template slot="FosterYesNo" scope="props">
                <div class="FosterYesNo" v-if="props.rowData.Church.IsInvolvedWithFoster">
                    <font-awesome-icon :icon="['fa', 'check']" class="olive-green-text" />
                </div>
                <div class="FosterYesNo" v-else>
                    <font-awesome-icon :icon="['fa', 'times']" class="red" />
                </div>
            </template>
            <template slot="SafeFamiliesYesNo" scope="props">
                <div class="SafeFamiliesYesNo" v-if="props.rowData.Church.IsInvolvedWithSafeFamilies">
                    <font-awesome-icon :icon="['fa', 'check']" class="olive-green-text" />
                </div>
                <div class="SafeFamiliesYesNo" v-else>
                    <font-awesome-icon :icon="['fa', 'times']" class="red" />
                </div>
            </template>
            <template slot="CommunityInvolvementYesNo" scope="props">
                <div class="CommunityInvolvementYesNo" v-if="props.rowData.Church.IsInvolvedWithCommunityInvolvement">
                    <font-awesome-icon :icon="['fa', 'check']" class="olive-green-text" />
                </div>
                <div class="CommunityInvolvementYesNo" v-else>
                    <font-awesome-icon :icon="['fa', 'times']" class="red" />
                </div>
            </template>
        </vuetable>
    </div>
</template>

<script>

    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faTimes } from '@fortawesome/free-solid-svg-icons';
    library.add(faTimes);

    export default {
        created() {
            this.$store.commit("Churches.ChurchProfiles.Clear");
            this.$store.commit("Churches.ChurchEnrollmentsList.Clear");
        },
        props: [],
        data: function () {
            return {
                //TableSearch: "",
                search: "",
                Filters: {
                    Region: "All",
                    SubProgramID: "",
                    OwnerOfRelationship: ""
                },
                ChurchTableOptions: {
                    Fields: [
                        {
                            name: '__slot:ChurchRecordLink',
                            title: 'Name',
                            sortField: 'Church.Name'
                        },
                        {
                            name: 'Church.Name',
                            title: 'Name',
                            visible: false
                        },
                        {
                            name: 'SubProgramMembership.StartDate',
                            title: "Relationship Started",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'SubProgramMembership.StartDate'
                        },
                        //{
                        //    name: 'SubProgramMembership.SubProgram.Name',
                        //    title: "Program",
                        //    sortField: 'SubProgramMembership.SubProgram.Name'
                        //},
                        {
                            name: 'Church.Region',
                            title: "Territory",
                            sortField: 'Church.Region'
                        },
                        //{
                        //    name: 'Church.AddressPhysical.Address.City',
                        //    title: "Location",
                        //    sortField: 'Church.AddressPhysical.Address.City'
                        //},
                        {
                            name: '__slot:FosterYesNo',
                            title: "Foster",
                            sortField: 'Church.IsInvolvedWithFoster'
                        },
                        {
                            name: 'Church.FosterYesNo',
                            title: "Foster",
                            visible: false
                        },
                        {
                            name: '__slot:SafeFamiliesYesNo',
                            title: "SF",
                            sortField: 'Church.IsInvolvedWithSafeFamilies'
                        },
                        {
                            name: 'Church.IsInvolvedWithSafeFamilies',
                            title: "SF",
                            visible: false
                        },
                        {
                            name: '__slot:CommunityInvolvementYesNo',
                            title: "CI",
                            sortField: 'Church.IsInvolvedWithCommunityInvolvement'
                        },
                        {
                            name: 'Church.IsInvolvedWithCommunityInvolvement',
                            title: "CI",
                            visible: false
                        },
                        {
                            name: 'CurrentCareCommunityPhase',
                            title: "Care Community",
                            sortField: 'CurrentCareCommunityPhase'
                        },
                        {
                            name: 'CurrentOwnerOfRelationship',
                            title: "Owner of Relationship",
                            sortField: 'CurrentOwnerOfRelationship'
                        },
                        {
                            name: 'Church.LastInteraction',
                            title: "Last Interaction",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'Church.LastInteraction'
                        },
                        //{
                        //    name: 'ClientProgramMembership.SubProgramName',
                        //    title: "Program",
                        //    sortField: 'ClientProgramMembership.SubProgramName'
                        //},
                        //{
                        //    name: 'ClientProgramMembership.StartDate',
                        //    title: "Start Date",
                        //    callback: 'formatDate|MM/DD/YY',
                        //    sortField: 'ClientProgramMembership.StartDate'
                        //},
                        //{
                        //    name: 'ClientProgramMembership.EndDate',
                        //    title: "Term Date",
                        //    callback: 'formatDate|MM/DD/YY',
                        //    sortField: 'ClientProgramMembership.EndDate'
                        //},
                        //{
                        //    name: 'ResourceFamilies',
                        //    title: "Family",
                        //    callback: 'getCurrentFamilyName',
                        //    sortField: 'CurrentResourceFamily'
                        //},
                        //{
                        //    name: 'CaseManagers',
                        //    title: "Case Manager",
                        //    callback: 'getCurrentCaseManagerName',
                        //    sortField: 'CurrentCaseManager'
                        //},
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetChurches();
            },
            GetChurches() {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Churches.ChurchProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Churches.ChurchProfiles[key].Church.Id)
                });
                this.$MasterAPI.ExecuteRequest("GET", "ChurchEngagement/Church/GetChurches",
                    {
                        Region: this.Filters.Region,
                        SubProgramID: this.Filters.SubProgramID,
                        OwnerOfRelationship: this.Filters.OwnerOfRelationship,
                        AdditionalRecords: openRecords
                    }, this.GetChurchesSuccess, () => { }, false);

            },
            GetChurchesSuccess(response) {
                let vm = this;
                this.$store.commit("Churches.ChurchEnrollmentsList.Replace", response.data.data);
                for (var i = 0; i < vm.$store.state.Churches.ChurchEnrollmentsList.length; i++) {
                    if (vm.$store.state.Churches.ChurchEnrollmentsList[i].Church.LastInteraction === null)
                        vm.$store.state.Churches.ChurchEnrollmentsList[i].Church.LastInteraction ='';
                }
                this.$refs.datatable.refresh();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenChurchRecord(churchID, churchRecordData) {
                this.$store.commit("Churches.ChurchProfiles.Append", churchRecordData);

                this.$parent.ChangePaneShown(churchID);
            },
            
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.$store.state.Churches.ChurchEnrollmentsList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            },
            //GetLastInteraction(church) {
            //    console.log(church.GetLastInteraction);
            //    return church.GetLastInteraction;
            //}
            //SearchResult(input) {
            //    var tableInfo = Array.prototype.map.call(document.querySelectorAll('#childrendatatableid tbody tr'), function(tr){
            //            return Array.prototype.map.call(tr.querySelectorAll('td'), function(td){
            //                return td.innerHTML;
            //        });
            //    });
            //    console.log(tableInfo);
            //}
        },
        components: {
            Vuetable
        },
        computed: {
            //LoadedChurches: function () {
            //    if (this.TableSearch != "") {
            //        let vm = this;
            //        let results = []
            //        this.$store.state.Churches.ChurchEnrollmentsList.forEach(function (item) {
            //            let itemstring = JSON.stringify(item).toLowerCase();
            //            if (itemstring.includes(vm.TableSearch.toLowerCase())) {
            //                results.push(item);
            //            }
            //        });
            //        return results;
            //    } else {
            //        return this.$store.state.Churches.ChurchEnrollmentsList;
            //    }
            //},
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            var vm = this;
            //Get Child Records*/
            this.GetChurches();
            let getchurchesFunc = function () {
                vm.GetChurches();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getchurchesFunc);
            
        }
    }
</script>

<style scoped>
    .vue-datatable {
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
</style>